import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";



import "./styles/about.css";
import Service from "../service/Service";
import { useState} from "react";
import Skills from "../components/about/skills";
import Education from "../components/about/education";
import Certificate from "../components/about/certificate";
const About = () => {


	const [data, setData] = useState([]);
	
	useEffect(() => {
	  getData();
	}, []);
  
	const getData = async () => {
	  try {
		const documentData = await Service.getInfoById("about");
		if (documentData) {
		  setData(documentData);
		}
	  } catch (error) {
		console.error("Error fetching data:", error);
	  }
	};
  
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);


	return (
		<React.Fragment>
			

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<div className="title about-title">
									{data.title}
								</div>

								<div className="subtitle about-subtitle">
									{data.desc}
								</div>
								<div className="subtitle about-subtitle">
									{data.desc1}
								</div>
								<div className="subtitle about-subtitle">
									{data.desc2}
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src={data.img}
											alt="about"
											className="about-image"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials />
								</div>

								<Skills></Skills>
							</div>
							
						</div>
						<Education></Education>
						<Certificate></Certificate>
						<div className="about-socials-mobile">
							<Socials />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
